"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faFileArrowUp_1 = require("@fortawesome/pro-light-svg-icons/faFileArrowUp");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var styled_1 = __importDefault(require("@mui/material/styles/styled"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var Text_1 = __importDefault(require("shared/components/Text"));
var FileWrapper = (0, styled_1.default)('div')(function (_a) {
    var _b;
    var theme = _a.theme, isActive = _a.isActive;
    return (__assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: theme.spacing(1.25), margin: theme.spacing(0, -1), borderRadius: theme.shape.borderRadius, color: theme.palette.grey[600] }, isActive && { ':hover, :focus': { backgroundColor: (_b = theme.palette.neutral) === null || _b === void 0 ? void 0 : _b.light } }));
});
var FileListItem = function (_a) {
    var fileName = _a.fileName, onRemove = _a.onRemove;
    return ((0, jsx_runtime_1.jsxs)(FileWrapper, __assign({ isActive: !!onRemove }, { children: [(0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2 }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faFileArrowUp_1.faFileArrowUp, size: "lg", style: { marginRight: 7 } }), fileName] }), fileName), onRemove && (0, jsx_runtime_1.jsx)(IconButtons_1.RemoveButton, { size: "small", iconSize: 14, onClick: onRemove })] })));
};
exports.default = FileListItem;
